<div class="form-field">
  @if (label) {
  <label class="form-label" [for]="inputId">{{ label }}</label>
  }
  <textarea
    [id]="inputId"
    class="form-control form-control-textarea"
    (input)="onInput($event)"
    [value]="value"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [rows]="rows"
    [class.has-error]="hasError"
  ></textarea>
  @if (errorMessage) {
  <span class="error-message">{{ errorMessage }}</span>
  }
</div>
